module.exports = __webpack_public_path__ + "catalog/items/furniture/Sofa 4/Sofa4.svg";